import clsx from 'clsx';
import {
  ComponentPropsWithRef,
  FC,
  PropsWithChildren,
  ReactNode,
  Ref,
} from 'react';
import { LayoutCard } from '../layout/card.tsx';
import {
  highlightedSection,
  highlightedSectionHeader,
  listContainer,
  sectionLabel,
} from './highlighted-feed-wrapper.css.ts';

interface HighlightedFeedWrapperProps extends PropsWithChildren {
  ref?: Ref<HTMLDivElement>;
  label: string;
  action?: ReactNode;
  empty?: {
    state: ReactNode;
    isEmpty: boolean;
  };
  className?: string;
}

export const HighlightedFeedWrapper: FC<HighlightedFeedWrapperProps> = ({
  ref,
  label,
  action,
  empty,
  children,
  className,
}) => {
  return (
    <LayoutCard
      ref={ref}
      className={clsx(highlightedSection, className)}
      data-empty={empty?.isEmpty ? '' : undefined}
    >
      <div className={highlightedSectionHeader}>
        <h3 className={sectionLabel}>{label}</h3>
        {action}
      </div>
      {children}
      {empty && empty.isEmpty ? empty.state : null}
    </LayoutCard>
  );
};

export const List = function ListComponent(
  props: Omit<ComponentPropsWithRef<'div'>, 'className'>,
) {
  return <LayoutCard className={listContainer} {...props}></LayoutCard>;
};
